import { ofArray as ofArray_1, empty, length, sumBy, append, toArray, filter as filter_9, tryHead, collect, isEmpty, contains, sortBy, sortByDescending, exists, forAll, skip as skip_4, truncate as truncate_5, map as map_1, toList } from "./fable_modules/fable-library.3.7.12/Seq.js";
import { Array_countBy, groupBy, List_groupBy } from "./fable_modules/fable-library.3.7.12/Seq2.js";
import { safeHash, curry, partialApply, uncurry, stringHash, compare, structuralHash, equals } from "./fable_modules/fable-library.3.7.12/Util.js";
import { FSharpRef, Record } from "./fable_modules/fable-library.3.7.12/Types.js";
import { unit_type, float64_type, int32_type, array_type, record_type, option_type, class_type, string_type, bool_type, list_type, lambda_type } from "./fable_modules/fable-library.3.7.12/Reflection.js";
import { Context, ProjectSearchResult, ProductSearchResult, SalesListSearchResult, SparePartSearchResult, ResultCounts, ProjectFilter$reflection, ProductFilter$reflection, SparePartFilter$reflection, CentralLocalModule_toString, LookupFilter$reflection } from "./Context.fs.js";
import { printf, toText, join, isNullOrEmpty } from "./fable_modules/fable-library.3.7.12/String.js";
import { compare as compare_1, now as now_1, tryParse, minValue } from "./fable_modules/fable-library.3.7.12/Date.js";
import { Project$reflection, Product$reflection, SalesList$reflection, SparePart$reflection, Project, ProjectId, Product, ProductId, SalesList, SalesListId, SparePartIdModule_toString, SparePart, SparePartId, Battery, P84 as P84_1, SparePartChain, SparePartChainLink, Jpdm } from "../SparePartInfo/CommonTypes.fs.js";
import { foldBack, map as map_2 } from "./fable_modules/fable-library.3.7.12/Array.js";
import { concatNewLine, truncate as truncate_6, split, contains as contains_1, toOption, defaultValue } from "../../Fame/Core/String.fs.js";
import { value as value_5, some, defaultArg, map as map_3 } from "./fable_modules/fable-library.3.7.12/Option.js";
import { empty as empty_1, cons, choose, forAll as forAll_1, ofArray, map as map_4 } from "./fable_modules/fable-library.3.7.12/List.js";
import { LocaleModule_tryParse, Locale$reflection } from "../../Fame/Localization/Locale.fs.js";
import { ofSeq, FSharpMap__TryGetValue } from "./fable_modules/fable-library.3.7.12/Map.js";
import { tryParse as tryParse_1, minValue as minValue_1 } from "./fable_modules/fable-library.3.7.12/DateOffset.js";
import { singleton } from "./fable_modules/fable-library.3.7.12/AsyncBuilder.js";
import { Http_get } from "./fable_modules/Fable.SimpleHttp.3.3.0/Http.fs.js";
import { ExternalUrl } from "./Constants.fs.js";
import { Worksheet_ofData, SheetData$1, Col$1 } from "../../Import/Fable/Fable.XLSX.fs.js";
import * as xlsx from "xlsx";
import { Result_Map, FSharpResult$2 } from "./fable_modules/fable-library.3.7.12/Choice.js";
import { AsyncResultCE_asyncResult, AsyncResultCE_AsyncResultBuilder__Delay_Z64727ECD } from "./fable_modules/FsToolkit.ErrorHandling.2.13.0/AsyncResultCE.fs.js";
import { parallel } from "./fable_modules/fable-library.3.7.12/Async.js";

export function toResultList(skip, truncate, map, sequence) {
    return toList(map_1(map, truncate_5(truncate, skip_4(skip, sequence))));
}

export function combineFilterGroups(filters) {
    const fs = List_groupBy((tupledArg) => tupledArg[0], filters, {
        Equals: equals,
        GetHashCode: structuralHash,
    });
    return (entity) => forAll((tupledArg_1) => exists((tupledArg_2) => tupledArg_2[1](entity), tupledArg_1[1]), fs);
}

export function trueFun(_arg1) {
    return true;
}

export function falseFun(_arg1) {
    return false;
}

export class EntitySet$3 extends Record {
    constructor(toEntity, createFilter, createLookupFilter, createQuery, get$) {
        super();
        this.toEntity = toEntity;
        this.createFilter = createFilter;
        this.createLookupFilter = createLookupFilter;
        this.createQuery = createQuery;
        this.get = get$;
    }
}

export function EntitySet$3$reflection(gen0, gen1, gen2) {
    return record_type("Fame.Fts.Toolbox.SparePartInfo.UI.SimpleContext.EntitySet`3", [gen0, gen1, gen2], EntitySet$3, () => [["toEntity", lambda_type(gen0, gen1)], ["createFilter", lambda_type(list_type(gen2), lambda_type(gen0, bool_type))], ["createLookupFilter", lambda_type(LookupFilter$reflection(), lambda_type(gen0, bool_type))], ["createQuery", lambda_type(class_type("System.Collections.Generic.IEnumerable`1", [string_type]), lambda_type(gen0, bool_type))], ["get", lambda_type(string_type, lambda_type(class_type("System.Collections.Generic.IEnumerable`1", [gen0]), option_type(gen1)))]]);
}

function Dto_tryParseDate(input) {
    if (isNullOrEmpty(input)) {
        return void 0;
    }
    else {
        let matchValue;
        let outArg = minValue();
        matchValue = [tryParse(input, new FSharpRef(() => outArg, (v) => {
            outArg = v;
        })), outArg];
        if (matchValue[0]) {
            return matchValue[1];
        }
        else {
            return void 0;
        }
    }
}

class Dto_Jpdm extends Record {
    constructor(KaufteilSachnummer, Hersteller, Modellnummer, ProduktNummer) {
        super();
        this.KaufteilSachnummer = KaufteilSachnummer;
        this.Hersteller = Hersteller;
        this.Modellnummer = Modellnummer;
        this.ProduktNummer = ProduktNummer;
    }
}

function Dto_Jpdm$reflection() {
    return record_type("Fame.Fts.Toolbox.SparePartInfo.UI.SimpleContext.Dto.Jpdm", [], Dto_Jpdm, () => [["KaufteilSachnummer", string_type], ["Hersteller", string_type], ["Modellnummer", string_type], ["ProduktNummer", string_type]]);
}

function Dto_JpdmModule_toEntity(jpdm) {
    return new Jpdm(jpdm.KaufteilSachnummer, jpdm.Hersteller, jpdm.Modellnummer, jpdm.ProduktNummer);
}

class Dto_SparePartChainLink extends Record {
    constructor(MaterialNo, B0MAT, SUBMAT, BISMAT) {
        super();
        this.MaterialNo = MaterialNo;
        this.B0MAT = B0MAT;
        this.SUBMAT = SUBMAT;
        this.BISMAT = BISMAT;
    }
}

function Dto_SparePartChainLink$reflection() {
    return record_type("Fame.Fts.Toolbox.SparePartInfo.UI.SimpleContext.Dto.SparePartChainLink", [], Dto_SparePartChainLink, () => [["MaterialNo", string_type], ["B0MAT", string_type], ["SUBMAT", string_type], ["BISMAT", string_type]]);
}

function Dto_SparePartChainLinkModule_toEntity(l) {
    return new SparePartChainLink(l.MaterialNo, l.B0MAT, l.SUBMAT, l.BISMAT);
}

class Dto_SparePartChain extends Record {
    constructor(ChainId, Links) {
        super();
        this.ChainId = ChainId;
        this.Links = Links;
    }
}

function Dto_SparePartChain$reflection() {
    return record_type("Fame.Fts.Toolbox.SparePartInfo.UI.SimpleContext.Dto.SparePartChain", [], Dto_SparePartChain, () => [["ChainId", string_type], ["Links", array_type(Dto_SparePartChainLink$reflection())]]);
}

function Dto_SparePartChainModule_toEntity(c) {
    return new SparePartChain(c.ChainId, map_2(Dto_SparePartChainLinkModule_toEntity, c.Links));
}

class Dto_P84 extends Record {
    constructor(MaterialNummer, KurztextE, Vertriebstext1E, Vmsta_01, Vmsta_31, JpdmMmsta, P84Mmsta, OrderableFrom, DeliverableFrom, LimmitedAvailability, EolControlDate) {
        super();
        this.MaterialNummer = MaterialNummer;
        this.KurztextE = KurztextE;
        this.Vertriebstext1E = Vertriebstext1E;
        this.Vmsta_01 = Vmsta_01;
        this.Vmsta_31 = Vmsta_31;
        this.JpdmMmsta = JpdmMmsta;
        this.P84Mmsta = P84Mmsta;
        this.OrderableFrom = OrderableFrom;
        this.DeliverableFrom = DeliverableFrom;
        this.LimmitedAvailability = LimmitedAvailability;
        this.EolControlDate = EolControlDate;
    }
}

function Dto_P84$reflection() {
    return record_type("Fame.Fts.Toolbox.SparePartInfo.UI.SimpleContext.Dto.P84", [], Dto_P84, () => [["MaterialNummer", string_type], ["KurztextE", string_type], ["Vertriebstext1E", string_type], ["Vmsta_01", string_type], ["Vmsta_31", string_type], ["JpdmMmsta", string_type], ["P84Mmsta", string_type], ["OrderableFrom", string_type], ["DeliverableFrom", string_type], ["LimmitedAvailability", string_type], ["EolControlDate", string_type]]);
}

function Dto_P84Module_toEntity(p84) {
    return new P84_1(p84.MaterialNummer, p84.KurztextE, p84.Vertriebstext1E, p84.Vmsta_01, p84.Vmsta_31, p84.JpdmMmsta, p84.P84Mmsta, void 0, void 0, p84.LimmitedAvailability, void 0);
}

class Dto_Battery extends Record {
    constructor(IECCode, BATTKZ, Battchargetype, Battmatcomp, Battdef1, Manufacturer, LIContent, CapperBatt, BATTCELLS, Battweight, BattweightUnit) {
        super();
        this.IECCode = IECCode;
        this.BATTKZ = BATTKZ;
        this.Battchargetype = Battchargetype;
        this.Battmatcomp = Battmatcomp;
        this.Battdef1 = Battdef1;
        this.Manufacturer = Manufacturer;
        this.LIContent = LIContent;
        this.CapperBatt = CapperBatt;
        this.BATTCELLS = BATTCELLS;
        this.Battweight = Battweight;
        this.BattweightUnit = BattweightUnit;
    }
}

function Dto_Battery$reflection() {
    return record_type("Fame.Fts.Toolbox.SparePartInfo.UI.SimpleContext.Dto.Battery", [], Dto_Battery, () => [["IECCode", string_type], ["BATTKZ", string_type], ["Battchargetype", string_type], ["Battmatcomp", string_type], ["Battdef1", string_type], ["Manufacturer", string_type], ["LIContent", string_type], ["CapperBatt", string_type], ["BATTCELLS", option_type(int32_type)], ["Battweight", option_type(float64_type)], ["BattweightUnit", string_type]]);
}

function Dto_BatteryModule_toBattery(battery) {
    return new Battery(battery.IECCode, battery.BATTKZ, battery.Battchargetype, battery.Battmatcomp, battery.Battdef1, battery.Manufacturer, battery.LIContent, battery.CapperBatt, battery.BATTCELLS, battery.Battweight, battery.BattweightUnit);
}

class Dto_SparePart extends Record {
    constructor(MaterialNo, PartNumber, Description, DescriptionDe, SPART, ProductHierarchy, VendorPartNo, TechnicalInfo, ReturnCode, RepairCode, ListPrice, CreditPrice, Currenry, CRU, SubstituteMaterial, AlternativePart, CentrolLocalFlag, MainAlternativePart, EOLL, EOLC, ZZPLAKT, EKGRP, CommodityCode, LegalControlDE, LegalControlEN, CountryofOrigin, RoHSKz, DangerousGoods, HazardousMaterialNumber, ArticleNumberBattery1, ArticleNumberBattery2, ExternalPackaging, InternalPackaging, ESDBag, GrossWeight, NetWeight, WeightUnit, Volume, VolumeUnit, Length, Width, Height, DimensionUnit, CriticalPart, SupplierCreditorNo, RepairerCreditorNo, RepairerPartNo, GeneralInfo, PrecheckInfo, InboundInfo, ReturnInfo, MaterialKind, NotInStore, MoreInfo, UseUp, LastCall, RepairOnly, PekuniaModelNo, ChainId, MS80, ProductCode, DataSecurity, SerialNoPrefix, CreationDate, Compas, Batteries, Jpdms, P84, ProductIds, SaleListIds) {
        super();
        this.MaterialNo = MaterialNo;
        this.PartNumber = PartNumber;
        this.Description = Description;
        this.DescriptionDe = DescriptionDe;
        this.SPART = SPART;
        this.ProductHierarchy = ProductHierarchy;
        this.VendorPartNo = VendorPartNo;
        this.TechnicalInfo = TechnicalInfo;
        this.ReturnCode = ReturnCode;
        this.RepairCode = RepairCode;
        this.ListPrice = ListPrice;
        this.CreditPrice = CreditPrice;
        this.Currenry = Currenry;
        this.CRU = CRU;
        this.SubstituteMaterial = SubstituteMaterial;
        this.AlternativePart = AlternativePart;
        this.CentrolLocalFlag = CentrolLocalFlag;
        this.MainAlternativePart = MainAlternativePart;
        this.EOLL = EOLL;
        this.EOLC = EOLC;
        this.ZZPLAKT = ZZPLAKT;
        this.EKGRP = EKGRP;
        this.CommodityCode = CommodityCode;
        this.LegalControlDE = LegalControlDE;
        this.LegalControlEN = LegalControlEN;
        this.CountryofOrigin = CountryofOrigin;
        this.RoHSKz = RoHSKz;
        this.DangerousGoods = DangerousGoods;
        this.HazardousMaterialNumber = HazardousMaterialNumber;
        this.ArticleNumberBattery1 = ArticleNumberBattery1;
        this.ArticleNumberBattery2 = ArticleNumberBattery2;
        this.ExternalPackaging = ExternalPackaging;
        this.InternalPackaging = InternalPackaging;
        this.ESDBag = ESDBag;
        this.GrossWeight = GrossWeight;
        this.NetWeight = NetWeight;
        this.WeightUnit = WeightUnit;
        this.Volume = Volume;
        this.VolumeUnit = VolumeUnit;
        this.Length = Length;
        this.Width = Width;
        this.Height = Height;
        this.DimensionUnit = DimensionUnit;
        this.CriticalPart = CriticalPart;
        this.SupplierCreditorNo = SupplierCreditorNo;
        this.RepairerCreditorNo = RepairerCreditorNo;
        this.RepairerPartNo = RepairerPartNo;
        this.GeneralInfo = GeneralInfo;
        this.PrecheckInfo = PrecheckInfo;
        this.InboundInfo = InboundInfo;
        this.ReturnInfo = ReturnInfo;
        this.MaterialKind = MaterialKind;
        this.NotInStore = NotInStore;
        this.MoreInfo = MoreInfo;
        this.UseUp = UseUp;
        this.LastCall = LastCall;
        this.RepairOnly = RepairOnly;
        this.PekuniaModelNo = PekuniaModelNo;
        this.ChainId = ChainId;
        this.MS80 = MS80;
        this.ProductCode = ProductCode;
        this.DataSecurity = DataSecurity;
        this.SerialNoPrefix = SerialNoPrefix;
        this.CreationDate = CreationDate;
        this.Compas = Compas;
        this.Batteries = Batteries;
        this.Jpdms = Jpdms;
        this.P84 = P84;
        this.ProductIds = ProductIds;
        this.SaleListIds = SaleListIds;
    }
}

function Dto_SparePart$reflection() {
    return record_type("Fame.Fts.Toolbox.SparePartInfo.UI.SimpleContext.Dto.SparePart", [], Dto_SparePart, () => [["MaterialNo", string_type], ["PartNumber", string_type], ["Description", string_type], ["DescriptionDe", string_type], ["SPART", string_type], ["ProductHierarchy", string_type], ["VendorPartNo", string_type], ["TechnicalInfo", array_type(string_type)], ["ReturnCode", string_type], ["RepairCode", string_type], ["ListPrice", option_type(float64_type)], ["CreditPrice", option_type(float64_type)], ["Currenry", string_type], ["CRU", bool_type], ["SubstituteMaterial", string_type], ["AlternativePart", string_type], ["CentrolLocalFlag", string_type], ["MainAlternativePart", string_type], ["EOLL", string_type], ["EOLC", string_type], ["ZZPLAKT", string_type], ["EKGRP", string_type], ["CommodityCode", string_type], ["LegalControlDE", string_type], ["LegalControlEN", string_type], ["CountryofOrigin", string_type], ["RoHSKz", string_type], ["DangerousGoods", string_type], ["HazardousMaterialNumber", string_type], ["ArticleNumberBattery1", string_type], ["ArticleNumberBattery2", string_type], ["ExternalPackaging", string_type], ["InternalPackaging", string_type], ["ESDBag", string_type], ["GrossWeight", option_type(float64_type)], ["NetWeight", option_type(float64_type)], ["WeightUnit", string_type], ["Volume", option_type(float64_type)], ["VolumeUnit", string_type], ["Length", option_type(float64_type)], ["Width", option_type(float64_type)], ["Height", option_type(float64_type)], ["DimensionUnit", string_type], ["CriticalPart", option_type(bool_type)], ["SupplierCreditorNo", string_type], ["RepairerCreditorNo", string_type], ["RepairerPartNo", string_type], ["GeneralInfo", array_type(string_type)], ["PrecheckInfo", array_type(string_type)], ["InboundInfo", array_type(string_type)], ["ReturnInfo", array_type(string_type)], ["MaterialKind", string_type], ["NotInStore", bool_type], ["MoreInfo", bool_type], ["UseUp", bool_type], ["LastCall", bool_type], ["RepairOnly", bool_type], ["PekuniaModelNo", string_type], ["ChainId", string_type], ["MS80", string_type], ["ProductCode", string_type], ["DataSecurity", string_type], ["SerialNoPrefix", string_type], ["CreationDate", string_type], ["Compas", array_type(string_type)], ["Batteries", array_type(Dto_Battery$reflection())], ["Jpdms", array_type(Dto_Jpdm$reflection())], ["P84", option_type(Dto_P84$reflection())], ["ProductIds", array_type(string_type)], ["SaleListIds", array_type(string_type)]]);
}

function Dto_sortBy(direction, projection, source) {
    if (direction.tag === 1) {
        return sortByDescending(projection, source, {
            Compare: compare,
        });
    }
    else {
        return sortBy(projection, source, {
            Compare: compare,
        });
    }
}

function Dto_SparePartModule_toEntity(getCreditorName, getSparePartChain, sparePart) {
    const DescriptionDE = defaultValue(sparePart.Description, sparePart.DescriptionDe);
    const EndOfService = Dto_tryParseDate(sparePart.EOLC);
    const EndOfServiceMax = Dto_tryParseDate(sparePart.EOLL);
    const SupplierCreditorName = getCreditorName(sparePart.SupplierCreditorNo);
    const RepairerCreditorName = getCreditorName(sparePart.RepairerCreditorNo);
    const PekuniaModelNo = toOption(sparePart.PekuniaModelNo);
    const Chain = getSparePartChain(sparePart.ChainId);
    const MS80 = Dto_tryParseDate(sparePart.MS80);
    const CreationDate = Dto_tryParseDate(sparePart.CreationDate);
    const Batteries = map_2(Dto_BatteryModule_toBattery, sparePart.Batteries);
    const Jpdms = map_2(Dto_JpdmModule_toEntity, sparePart.Jpdms);
    const P84 = map_3(Dto_P84Module_toEntity, sparePart.P84);
    return new SparePart(new SparePartId(0, sparePart.MaterialNo), sparePart.PartNumber, sparePart.Description, DescriptionDE, sparePart.SPART, sparePart.ProductHierarchy, sparePart.VendorPartNo, sparePart.ProductCode, sparePart.TechnicalInfo, sparePart.ReturnCode, sparePart.RepairCode, sparePart.ListPrice, EndOfService, EndOfServiceMax, sparePart.CreditPrice, sparePart.Currenry, sparePart.CRU, sparePart.SubstituteMaterial, sparePart.AlternativePart, sparePart.CentrolLocalFlag, sparePart.MainAlternativePart, sparePart.ZZPLAKT, sparePart.EKGRP, sparePart.DataSecurity, MS80, sparePart.CommodityCode, sparePart.LegalControlDE, sparePart.LegalControlEN, sparePart.CountryofOrigin, sparePart.RoHSKz, sparePart.DangerousGoods, sparePart.HazardousMaterialNumber, sparePart.ArticleNumberBattery1, sparePart.ArticleNumberBattery2, sparePart.ExternalPackaging, sparePart.InternalPackaging, sparePart.ESDBag, sparePart.GrossWeight, sparePart.NetWeight, sparePart.WeightUnit, sparePart.Volume, sparePart.VolumeUnit, sparePart.Length, sparePart.Width, sparePart.Height, sparePart.DimensionUnit, sparePart.CriticalPart, sparePart.SupplierCreditorNo, SupplierCreditorName, sparePart.RepairerCreditorNo, RepairerCreditorName, sparePart.RepairerPartNo, sparePart.GeneralInfo, sparePart.PrecheckInfo, sparePart.InboundInfo, sparePart.ReturnInfo, sparePart.SerialNoPrefix, sparePart.MaterialKind, sparePart.NotInStore, sparePart.MoreInfo, sparePart.UseUp, sparePart.LastCall, sparePart.RepairOnly, CreationDate, sparePart.ProductIds.length, sparePart.SaleListIds.length, Chain, Batteries, PekuniaModelNo, Jpdms, P84, sparePart.Compas);
}

function Dto_SparePartModule_createFilter(filters) {
    const now = now_1();
    return combineFilterGroups(map_4((_arg1) => {
        switch (_arg1.tag) {
            case 1: {
                return [1, (sp_1) => (sp_1.SPART === _arg1.fields[0])];
            }
            case 2: {
                const h = _arg1.fields[0];
                return [2, (h.length === 2) ? ((sp_2) => {
                    const input = sp_2.ProductHierarchy;
                    return (input == null) ? false : (input.indexOf(h) === 0);
                }) : ((sp_3) => (sp_3.ProductHierarchy === h))];
            }
            case 5: {
                return [3, (sp_4) => equals(sp_4.CriticalPart, _arg1.fields[0])];
            }
            case 6: {
                return [4, (sp_5) => {
                    const matchValue = Dto_tryParseDate(sp_5.EOLC);
                    return (matchValue != null) ? ((compare_1(matchValue, now) < 0) === _arg1.fields[0]) : true;
                }];
            }
            case 7: {
                return [5, (sp_6) => (CentralLocalModule_toString(_arg1.fields[0]) === sp_6.CentrolLocalFlag)];
            }
            case 3: {
                return [6, (sp_7) => (sp_7.ZZPLAKT === _arg1.fields[0])];
            }
            case 4: {
                return [7, (sp_8) => (sp_8.EKGRP === _arg1.fields[0])];
            }
            default: {
                const matno = SparePartIdModule_toString(_arg1.fields[0]);
                return [0, (sp) => (sp.MaterialNo === matno)];
            }
        }
    }, filters));
}

function Dto_SparePartModule_createLookupFilter(lookup) {
    switch (lookup.tag) {
        case 1: {
            return (sp) => contains(lookup.fields[0].fields[0], sp.SaleListIds, {
                Equals: (x, y) => (x === y),
                GetHashCode: stringHash,
            });
        }
        case 2: {
            return (sp_1) => contains(lookup.fields[0].fields[0], sp_1.ProductIds, {
                Equals: (x_1, y_1) => (x_1 === y_1),
                GetHashCode: stringHash,
            });
        }
        case 3: {
            return falseFun;
        }
        default: {
            return falseFun;
        }
    }
}

const Dto_SparePartModule_queryFilter = [(queries) => ((p) => forAll((query) => {
    const lowerContainsQuery = (input) => contains_1(query, input.toLowerCase());
    if ((((((((((lowerContainsQuery(p.MaterialNo) ? true : lowerContainsQuery(p.PartNumber)) ? true : lowerContainsQuery(p.Description)) ? true : lowerContainsQuery(p.DescriptionDe)) ? true : lowerContainsQuery(p.PekuniaModelNo)) ? true : lowerContainsQuery(p.VendorPartNo)) ? true : lowerContainsQuery(p.ProductCode)) ? true : p.TechnicalInfo.some(lowerContainsQuery)) ? true : p.GeneralInfo.some(lowerContainsQuery)) ? true : p.PrecheckInfo.some(lowerContainsQuery)) ? true : p.InboundInfo.some(lowerContainsQuery)) {
        return true;
    }
    else {
        return p.ReturnInfo.some(lowerContainsQuery);
    }
}, queries)), (queries_1) => ((p_1) => (isEmpty(p_1.Jpdms) ? false : exists((c) => exists((q) => (q === c), queries_1), collect((j) => ofArray([j.KaufteilSachnummer.toLowerCase(), j.Modellnummer.toLowerCase(), j.ProduktNummer.toLowerCase()]), p_1.Jpdms)))), (queries_2) => ((p_2) => (isEmpty(p_2.Compas) ? false : exists((c_1) => exists((q_1) => contains_1(q_1, c_1), queries_2), map_1((str_4) => str_4.toLowerCase(), p_2.Compas)))), (queries_3) => ((p_3) => {
    const matchValue = p_3.P84;
    if (matchValue != null) {
        const p84 = matchValue;
        return exists((q_2) => (q_2 === p84.MaterialNummer), queries_3);
    }
    else {
        return false;
    }
})];

function Dto_SparePartModule_sortByField(direction, field, getCreditorName) {
    switch (field) {
        case "partNumber": {
            return (source_1) => Dto_sortBy(direction, (s_1) => s_1.PartNumber, source_1);
        }
        case "description": {
            return (source_2) => Dto_sortBy(direction, (s_2) => s_2.Description, source_2);
        }
        case "descriptionDE": {
            return (source_3) => Dto_sortBy(direction, (s_3) => defaultValue(s_3.Description, s_3.DescriptionDe), source_3);
        }
        case "division": {
            return (source_4) => Dto_sortBy(direction, (s_4) => s_4.SPART, source_4);
        }
        case "productHierarchy": {
            return (source_5) => Dto_sortBy(direction, (s_5) => s_5.ProductHierarchy, source_5);
        }
        case "vendorPartNo": {
            return (source_6) => Dto_sortBy(direction, (s_6) => s_6.VendorPartNo, source_6);
        }
        case "productCode": {
            return (source_7) => Dto_sortBy(direction, (s_7) => s_7.ProductCode, source_7);
        }
        case "technicalInfo": {
            return (source_9) => Dto_sortBy(direction, (s_8) => defaultArg(tryHead(s_8.TechnicalInfo), ""), source_9);
        }
        case "returnCode": {
            return (source_10) => Dto_sortBy(direction, (s_9) => s_9.ReturnCode, source_10);
        }
        case "repairCode": {
            return (source_11) => Dto_sortBy(direction, (s_10) => s_10.RepairCode, source_11);
        }
        case "listPrice": {
            return (source_12) => Dto_sortBy(direction, (s_11) => s_11.ListPrice, source_12);
        }
        case "endOfService": {
            return (source_13) => Dto_sortBy(direction, (s_12) => s_12.EOLC, source_13);
        }
        case "endOfServiceMax": {
            return (source_14) => Dto_sortBy(direction, (s_13) => s_13.EOLL, source_14);
        }
        case "creditPrice": {
            return (source_15) => Dto_sortBy(direction, (s_14) => s_14.CreditPrice, source_15);
        }
        case "currency": {
            return (source_16) => Dto_sortBy(direction, (s_15) => s_15.Currenry, source_16);
        }
        case "cRU": {
            return (source_17) => Dto_sortBy(direction, (s_16) => s_16.CRU, source_17);
        }
        case "substituteMaterial": {
            return (source_18) => Dto_sortBy(direction, (s_17) => s_17.SubstituteMaterial, source_18);
        }
        case "alternativePart": {
            return (source_19) => Dto_sortBy(direction, (s_18) => s_18.AlternativePart, source_19);
        }
        case "centralLocal": {
            return (source_20) => Dto_sortBy(direction, (s_19) => s_19.CentrolLocalFlag, source_20);
        }
        case "mainAlternativePart": {
            return (source_21) => Dto_sortBy(direction, (s_20) => s_20.MainAlternativePart, source_21);
        }
        case "engineer": {
            return (source_22) => Dto_sortBy(direction, (s_21) => s_21.ZZPLAKT, source_22);
        }
        case "planner": {
            return (source_23) => Dto_sortBy(direction, (s_22) => s_22.EKGRP, source_23);
        }
        case "dataSecurity": {
            return (source_24) => Dto_sortBy(direction, (s_23) => s_23.DataSecurity, source_24);
        }
        case "mS80": {
            return (source_25) => Dto_sortBy(direction, (s_24) => s_24.MS80, source_25);
        }
        case "commodityCode": {
            return (source_26) => Dto_sortBy(direction, (s_25) => s_25.CommodityCode, source_26);
        }
        case "legalControlDE": {
            return (source_27) => Dto_sortBy(direction, (s_26) => s_26.LegalControlDE, source_27);
        }
        case "legalControlEN": {
            return (source_28) => Dto_sortBy(direction, (s_27) => s_27.LegalControlEN, source_28);
        }
        case "countryOfOrigin": {
            return (source_29) => Dto_sortBy(direction, (s_28) => s_28.CountryofOrigin, source_29);
        }
        case "roHSKz": {
            return (source_30) => Dto_sortBy(direction, (s_29) => s_29.RoHSKz, source_30);
        }
        case "dangerousGoods": {
            return (source_31) => Dto_sortBy(direction, (s_30) => s_30.DangerousGoods, source_31);
        }
        case "hazardousMaterialNumber": {
            return (source_32) => Dto_sortBy(direction, (s_31) => s_31.HazardousMaterialNumber, source_32);
        }
        case "articleNumberBattery1": {
            return (source_33) => Dto_sortBy(direction, (s_32) => s_32.ArticleNumberBattery1, source_33);
        }
        case "articleNumberBattery2": {
            return (source_34) => Dto_sortBy(direction, (s_33) => s_33.ArticleNumberBattery2, source_34);
        }
        case "externalPackaging": {
            return (source_35) => Dto_sortBy(direction, (s_34) => s_34.ExternalPackaging, source_35);
        }
        case "internalPackaging": {
            return (source_36) => Dto_sortBy(direction, (s_35) => s_35.InternalPackaging, source_36);
        }
        case "eSDBag": {
            return (source_37) => Dto_sortBy(direction, (s_36) => s_36.ESDBag, source_37);
        }
        case "grossWeight": {
            return (source_38) => Dto_sortBy(direction, (s_37) => s_37.GrossWeight, source_38);
        }
        case "netWeight": {
            return (source_39) => Dto_sortBy(direction, (s_38) => s_38.NetWeight, source_39);
        }
        case "weightUnit": {
            return (source_40) => Dto_sortBy(direction, (s_39) => s_39.WeightUnit, source_40);
        }
        case "volume": {
            return (source_41) => Dto_sortBy(direction, (s_40) => s_40.Volume, source_41);
        }
        case "volumeUnit": {
            return (source_42) => Dto_sortBy(direction, (s_41) => s_41.VolumeUnit, source_42);
        }
        case "dimensions":
        case "length": {
            return (source_43) => Dto_sortBy(direction, (s_42) => s_42.Length, source_43);
        }
        case "width": {
            return (source_44) => Dto_sortBy(direction, (s_43) => s_43.Width, source_44);
        }
        case "height": {
            return (source_45) => Dto_sortBy(direction, (s_44) => s_44.Height, source_45);
        }
        case "dimensionUnit": {
            return (source_46) => Dto_sortBy(direction, (s_45) => s_45.DimensionUnit, source_46);
        }
        case "criticalPart": {
            return (source_47) => Dto_sortBy(direction, (s_46) => s_46.CriticalPart, source_47);
        }
        case "supplier":
        case "supplierCreditorNo": {
            return (source_48) => Dto_sortBy(direction, (s_47) => s_47.SupplierCreditorNo, source_48);
        }
        case "supplierCreditorName": {
            return (source_49) => Dto_sortBy(direction, (s_48) => getCreditorName(s_48.SupplierCreditorNo), source_49);
        }
        case "repairer":
        case "repairerCreditorNo": {
            return (source_50) => Dto_sortBy(direction, (s_49) => s_49.RepairerCreditorNo, source_50);
        }
        case "repairerCreditorName": {
            return (source_51) => Dto_sortBy(direction, (s_50) => getCreditorName(s_50.RepairerCreditorNo), source_51);
        }
        case "repairerPartNo": {
            return (source_52) => Dto_sortBy(direction, (s_51) => s_51.RepairerPartNo, source_52);
        }
        case "generalInfo": {
            return (source_54) => Dto_sortBy(direction, (s_52) => defaultArg(tryHead(s_52.GeneralInfo), ""), source_54);
        }
        case "precheckInfo": {
            return (source_56) => Dto_sortBy(direction, (s_53) => defaultArg(tryHead(s_53.PrecheckInfo), ""), source_56);
        }
        case "inboundInfo": {
            return (source_58) => Dto_sortBy(direction, (s_54) => defaultArg(tryHead(s_54.InboundInfo), ""), source_58);
        }
        case "returnInfo": {
            return (source_60) => Dto_sortBy(direction, (s_55) => defaultArg(tryHead(s_55.ReturnInfo), ""), source_60);
        }
        case "serialNoPrefix":
        case "serialNoHint": {
            return (source_61) => Dto_sortBy(direction, (s_56) => s_56.SerialNoPrefix, source_61);
        }
        case "materialKind": {
            return (source_62) => Dto_sortBy(direction, (s_57) => s_57.MaterialKind, source_62);
        }
        case "notInStore": {
            return (source_63) => Dto_sortBy(direction, (s_58) => s_58.NotInStore, source_63);
        }
        case "moreInfo": {
            return (source_64) => Dto_sortBy(direction, (s_59) => s_59.MoreInfo, source_64);
        }
        case "useUp": {
            return (source_65) => Dto_sortBy(direction, (s_60) => s_60.UseUp, source_65);
        }
        case "lastCall": {
            return (source_66) => Dto_sortBy(direction, (s_61) => s_61.LastCall, source_66);
        }
        case "repairOnly": {
            return (source_67) => Dto_sortBy(direction, (s_62) => s_62.RepairOnly, source_67);
        }
        case "creationDate": {
            return (source_68) => Dto_sortBy(direction, (s_63) => s_63.CreationDate, source_68);
        }
        case "usedInProducts": {
            return (source_69) => Dto_sortBy(direction, (s_64) => s_64.ProductIds.length, source_69);
        }
        case "usedInSalesLists": {
            return (source_70) => Dto_sortBy(direction, (s_65) => s_65.SaleListIds.length, source_70);
        }
        default: {
            return (source) => Dto_sortBy(direction, (s) => s.MaterialNo, source);
        }
    }
}

function Dto_SparePartModule_createQuery(queries, p) {
    return exists((fn) => fn(queries)(p), Dto_SparePartModule_queryFilter);
}

function Dto_SparePartModule_get(getCreditorName, getSparePartChain, no, entities) {
    return map_3((sparePart) => Dto_SparePartModule_toEntity(getCreditorName, getSparePartChain, sparePart), tryHead(filter_9((p) => (p.MaterialNo === no), entities)));
}

function Dto_SparePartModule_getEntitySet(getCreditorName, getSparePartChain) {
    return new EntitySet$3((sparePart) => Dto_SparePartModule_toEntity(getCreditorName, getSparePartChain, sparePart), uncurry(2, Dto_SparePartModule_createFilter), uncurry(2, Dto_SparePartModule_createLookupFilter), Dto_SparePartModule_createQuery, (no, entities) => Dto_SparePartModule_get(getCreditorName, getSparePartChain, no, entities));
}

class Dto_SalesList extends Record {
    constructor(MaterialNo, PartNumber, Description, SparePartIds, ProductIds) {
        super();
        this.MaterialNo = MaterialNo;
        this.PartNumber = PartNumber;
        this.Description = Description;
        this.SparePartIds = SparePartIds;
        this.ProductIds = ProductIds;
    }
}

function Dto_SalesList$reflection() {
    return record_type("Fame.Fts.Toolbox.SparePartInfo.UI.SimpleContext.Dto.SalesList", [], Dto_SalesList, () => [["MaterialNo", string_type], ["PartNumber", string_type], ["Description", string_type], ["SparePartIds", array_type(string_type)], ["ProductIds", array_type(string_type)]]);
}

function Dto_SalesListModule_toEntity(salesList) {
    return new SalesList(new SalesListId(0, salesList.MaterialNo), salesList.PartNumber, salesList.Description, salesList.SparePartIds.length, salesList.ProductIds.length);
}

function Dto_SalesListModule_createLookupFilter(lookup) {
    switch (lookup.tag) {
        case 1: {
            return falseFun;
        }
        case 2: {
            return (sp) => contains(lookup.fields[0].fields[0], sp.ProductIds, {
                Equals: (x_1, y_1) => (x_1 === y_1),
                GetHashCode: stringHash,
            });
        }
        case 3: {
            return falseFun;
        }
        default: {
            return (e) => contains(lookup.fields[0].fields[0], e.SparePartIds, {
                Equals: (x, y) => (x === y),
                GetHashCode: stringHash,
            });
        }
    }
}

function Dto_SalesListModule_createQuery(queries, p) {
    return forAll((query) => {
        if (contains_1(query, p.MaterialNo.toLowerCase()) ? true : contains_1(query, p.PartNumber.toLowerCase())) {
            return true;
        }
        else {
            return contains_1(query, p.Description.toLowerCase());
        }
    }, queries);
}

function Dto_SalesListModule_sortByField(direction, field) {
    switch (field) {
        case "partNumber": {
            return (source_1) => Dto_sortBy(direction, (s_1) => s_1.PartNumber, source_1);
        }
        case "description": {
            return (source_2) => Dto_sortBy(direction, (s_2) => s_2.Description, source_2);
        }
        case "usedInSpareParts": {
            return (source_3) => Dto_sortBy(direction, (s_3) => s_3.SparePartIds.length, source_3);
        }
        case "usedInProducts": {
            return (source_4) => Dto_sortBy(direction, (s_4) => s_4.ProductIds.length, source_4);
        }
        default: {
            return (source) => Dto_sortBy(direction, (s) => s.MaterialNo, source);
        }
    }
}

function Dto_SalesListModule_get(no, entities) {
    return map_3(Dto_SalesListModule_toEntity, tryHead(filter_9((p) => (p.MaterialNo === no), entities)));
}

function Dto_SalesListModule_entitySet() {
    return new EntitySet$3(Dto_SalesListModule_toEntity, (_arg2, _arg1) => true, uncurry(2, Dto_SalesListModule_createLookupFilter), Dto_SalesListModule_createQuery, Dto_SalesListModule_get);
}

class Dto_Product extends Record {
    constructor(MaterialNo, Productno, PartNumber, Description, DescriptionDE, ProductGroupPlant, ProductHierarchy, EndofLife, CRU, CentrolLocalFlag, PlanningInformation, ZZLVINT, ZZPLAKT, EXTWG, MS80, CreationDate, SparePartIds, SaleListIds, ProjectIds) {
        super();
        this.MaterialNo = MaterialNo;
        this.Productno = Productno;
        this.PartNumber = PartNumber;
        this.Description = Description;
        this.DescriptionDE = DescriptionDE;
        this.ProductGroupPlant = ProductGroupPlant;
        this.ProductHierarchy = ProductHierarchy;
        this.EndofLife = EndofLife;
        this.CRU = CRU;
        this.CentrolLocalFlag = CentrolLocalFlag;
        this.PlanningInformation = PlanningInformation;
        this.ZZLVINT = ZZLVINT;
        this.ZZPLAKT = ZZPLAKT;
        this.EXTWG = EXTWG;
        this.MS80 = MS80;
        this.CreationDate = CreationDate;
        this.SparePartIds = SparePartIds;
        this.SaleListIds = SaleListIds;
        this.ProjectIds = ProjectIds;
    }
}

function Dto_Product$reflection() {
    return record_type("Fame.Fts.Toolbox.SparePartInfo.UI.SimpleContext.Dto.Product", [], Dto_Product, () => [["MaterialNo", string_type], ["Productno", string_type], ["PartNumber", string_type], ["Description", string_type], ["DescriptionDE", string_type], ["ProductGroupPlant", string_type], ["ProductHierarchy", string_type], ["EndofLife", string_type], ["CRU", bool_type], ["CentrolLocalFlag", string_type], ["PlanningInformation", array_type(string_type)], ["ZZLVINT", string_type], ["ZZPLAKT", string_type], ["EXTWG", string_type], ["MS80", string_type], ["CreationDate", string_type], ["SparePartIds", array_type(string_type)], ["SaleListIds", array_type(string_type)], ["ProjectIds", array_type(string_type)]]);
}

function Dto_ProductModule_toEntity(product) {
    return new Product(new ProductId(0, product.MaterialNo), product.Productno, product.PartNumber, product.Description, defaultValue(product.Description, product.DescriptionDE), product.ProductGroupPlant, product.ProductHierarchy, Dto_tryParseDate(product.EndofLife), product.CRU, product.CentrolLocalFlag, product.PlanningInformation, Dto_tryParseDate(product.ZZLVINT), product.ZZPLAKT, product.EXTWG, Dto_tryParseDate(product.MS80), Dto_tryParseDate(product.CreationDate), product.SparePartIds.length, product.SaleListIds.length, product.ProjectIds.length);
}

function Dto_ProductModule_createFilter(filter) {
    const now = now_1();
    return combineFilterGroups(map_4((_arg1) => {
        switch (_arg1.tag) {
            case 3: {
                return [2, (p_1) => {
                    const matchValue = Dto_tryParseDate(p_1.EndofLife);
                    return (matchValue != null) ? ((compare_1(matchValue, now) < 0) === _arg1.fields[0]) : true;
                }];
            }
            case 1: {
                return [3, (sp) => (sp.ProductGroupPlant === _arg1.fields[0])];
            }
            case 4: {
                return [4, (sp_1) => (CentralLocalModule_toString(_arg1.fields[0]) === sp_1.CentrolLocalFlag)];
            }
            case 2: {
                return [5, (sp_2) => (sp_2.ZZPLAKT === _arg1.fields[0])];
            }
            default: {
                return [1, (p) => (p.ProductHierarchy === _arg1.fields[0])];
            }
        }
    }, filter));
}

function Dto_ProductModule_createLookupFilter(lookup) {
    switch (lookup.tag) {
        case 1: {
            return (e_1) => contains(lookup.fields[0].fields[0], e_1.SaleListIds, {
                Equals: (x_1, y_1) => (x_1 === y_1),
                GetHashCode: stringHash,
            });
        }
        case 2: {
            return falseFun;
        }
        case 3: {
            return (e_2) => contains(lookup.fields[0].fields[0], e_2.ProjectIds, {
                Equals: (x_2, y_2) => (x_2 === y_2),
                GetHashCode: stringHash,
            });
        }
        default: {
            return (e) => contains(lookup.fields[0].fields[0], e.SparePartIds, {
                Equals: (x, y) => (x === y),
                GetHashCode: stringHash,
            });
        }
    }
}

function Dto_ProductModule_createQuery(queries, p) {
    return forAll((query) => {
        if ((contains_1(query, p.MaterialNo.toLowerCase()) ? true : contains_1(query, p.Productno.toLowerCase())) ? true : contains_1(query, p.PartNumber.toLowerCase())) {
            return true;
        }
        else {
            return contains_1(query, p.Description.toLowerCase());
        }
    }, queries);
}

function Dto_ProductModule_sortByField(direction, field) {
    switch (field) {
        case "productNo": {
            return (source_1) => Dto_sortBy(direction, (s_1) => s_1.Productno, source_1);
        }
        case "partNumber": {
            return (source_2) => Dto_sortBy(direction, (s_2) => s_2.PartNumber, source_2);
        }
        case "description": {
            return (source_3) => Dto_sortBy(direction, (s_3) => s_3.Description, source_3);
        }
        case "descriptionDE": {
            return (source_4) => Dto_sortBy(direction, (s_4) => s_4.DescriptionDE, source_4);
        }
        case "productGroupPlant": {
            return (source_5) => Dto_sortBy(direction, (s_5) => s_5.ProductGroupPlant, source_5);
        }
        case "productHierarchy": {
            return (source_6) => Dto_sortBy(direction, (s_6) => s_6.ProductHierarchy, source_6);
        }
        case "endOfService": {
            return (source_7) => Dto_sortBy(direction, (s_7) => s_7.EndofLife, source_7);
        }
        case "cRU": {
            return (source_8) => Dto_sortBy(direction, (s_8) => s_8.MaterialNo, source_8);
        }
        case "centralLocal": {
            return (source_9) => Dto_sortBy(direction, (s_9) => s_9.MaterialNo, source_9);
        }
        case "planningInformation": {
            return (source_10) => Dto_sortBy(direction, (s_10) => s_10.MaterialNo, source_10);
        }
        case "endOfServiceMax": {
            return (source_11) => Dto_sortBy(direction, (s_11) => s_11.ZZLVINT, source_11);
        }
        case "engineer": {
            return (source_12) => Dto_sortBy(direction, (s_12) => s_12.ZZPLAKT, source_12);
        }
        case "eXTWG": {
            return (source_13) => Dto_sortBy(direction, (s_13) => s_13.EXTWG, source_13);
        }
        case "creationDate": {
            return (source_14) => Dto_sortBy(direction, (s_14) => s_14.CreationDate, source_14);
        }
        case "mS80": {
            return (source_15) => Dto_sortBy(direction, (s_15) => s_15.MS80, source_15);
        }
        case "usedInSpareParts": {
            return (source_16) => Dto_sortBy(direction, (s_16) => s_16.SparePartIds.length, source_16);
        }
        case "usedInSalesLists": {
            return (source_17) => Dto_sortBy(direction, (s_17) => s_17.SaleListIds.length, source_17);
        }
        case "usedInProjects": {
            return (source_18) => Dto_sortBy(direction, (s_18) => s_18.ProjectIds.length, source_18);
        }
        default: {
            return (source) => Dto_sortBy(direction, (s) => s.MaterialNo, source);
        }
    }
}

function Dto_ProductModule_get(no, entities) {
    return map_3(Dto_ProductModule_toEntity, tryHead(filter_9((p) => (p.MaterialNo === no), entities)));
}

const Dto_ProductModule_entitySet = new EntitySet$3(Dto_ProductModule_toEntity, uncurry(2, Dto_ProductModule_createFilter), uncurry(2, Dto_ProductModule_createLookupFilter), Dto_ProductModule_createQuery, Dto_ProductModule_get);

class Dto_Project extends Record {
    constructor(MaterialNo, Productno, PartNumber, Description, DescriptionDE, ProductGroupPlant, ProductHierarchy, EndOfLife, ZZLVINT, ZZPLAKT, ProductIds) {
        super();
        this.MaterialNo = MaterialNo;
        this.Productno = Productno;
        this.PartNumber = PartNumber;
        this.Description = Description;
        this.DescriptionDE = DescriptionDE;
        this.ProductGroupPlant = ProductGroupPlant;
        this.ProductHierarchy = ProductHierarchy;
        this.EndOfLife = EndOfLife;
        this.ZZLVINT = ZZLVINT;
        this.ZZPLAKT = ZZPLAKT;
        this.ProductIds = ProductIds;
    }
}

function Dto_Project$reflection() {
    return record_type("Fame.Fts.Toolbox.SparePartInfo.UI.SimpleContext.Dto.Project", [], Dto_Project, () => [["MaterialNo", string_type], ["Productno", string_type], ["PartNumber", string_type], ["Description", string_type], ["DescriptionDE", string_type], ["ProductGroupPlant", string_type], ["ProductHierarchy", string_type], ["EndOfLife", string_type], ["ZZLVINT", string_type], ["ZZPLAKT", string_type], ["ProductIds", array_type(string_type)]]);
}

function Dto_ProjectModule_toEntity(project) {
    return new Project(new ProjectId(0, project.MaterialNo), project.Productno, project.PartNumber, project.Description, defaultValue(project.Description, project.DescriptionDE), project.ProductGroupPlant, project.ProductHierarchy, Dto_tryParseDate(project.EndOfLife), Dto_tryParseDate(project.ZZLVINT), project.ZZPLAKT, project.ProductIds.length);
}

function Dto_ProjectModule_createFilter(filter) {
    const now = now_1();
    return combineFilterGroups(map_4((_arg1) => {
        switch (_arg1.tag) {
            case 3: {
                return [2, (p_1) => {
                    const matchValue = Dto_tryParseDate(p_1.ZZLVINT);
                    return (matchValue != null) ? ((compare_1(matchValue, now) < 0) === _arg1.fields[0]) : true;
                }];
            }
            case 1: {
                return [3, (sp) => (sp.ProductGroupPlant === _arg1.fields[0])];
            }
            case 2: {
                return [4, (sp_1) => (sp_1.ZZPLAKT === _arg1.fields[0])];
            }
            default: {
                return [1, (p) => (p.ProductHierarchy === _arg1.fields[0])];
            }
        }
    }, filter));
}

function Dto_ProjectModule_createLookupFilter(lookup) {
    switch (lookup.tag) {
        case 1: {
            return falseFun;
        }
        case 2: {
            return (e) => contains(lookup.fields[0].fields[0], e.ProductIds, {
                Equals: (x, y) => (x === y),
                GetHashCode: stringHash,
            });
        }
        case 3: {
            return falseFun;
        }
        default: {
            return falseFun;
        }
    }
}

function Dto_ProjectModule_createQuery(queries, p) {
    return forAll((query) => {
        if ((contains_1(query, p.MaterialNo.toLowerCase()) ? true : contains_1(query, p.Productno.toLowerCase())) ? true : contains_1(query, p.PartNumber.toLowerCase())) {
            return true;
        }
        else {
            return contains_1(query, p.Description.toLowerCase());
        }
    }, queries);
}

function Dto_ProjectModule_sortByField(direction, field) {
    switch (field) {
        case "productNo": {
            return (source_1) => Dto_sortBy(direction, (s_1) => s_1.Productno, source_1);
        }
        case "partNumber": {
            return (source_2) => Dto_sortBy(direction, (s_2) => s_2.PartNumber, source_2);
        }
        case "description": {
            return (source_3) => Dto_sortBy(direction, (s_3) => s_3.Description, source_3);
        }
        case "descriptionDE": {
            return (source_4) => Dto_sortBy(direction, (s_4) => s_4.DescriptionDE, source_4);
        }
        case "productGroupPlant": {
            return (source_5) => Dto_sortBy(direction, (s_5) => s_5.ProductGroupPlant, source_5);
        }
        case "productHierarchy": {
            return (source_6) => Dto_sortBy(direction, (s_6) => s_6.ProductHierarchy, source_6);
        }
        case "endOfService": {
            return (source_7) => Dto_sortBy(direction, (s_7) => s_7.EndOfLife, source_7);
        }
        case "endOfServiceMax": {
            return (source_8) => Dto_sortBy(direction, (s_8) => s_8.ZZLVINT, source_8);
        }
        case "engineer": {
            return (source_9) => Dto_sortBy(direction, (s_9) => s_9.ZZPLAKT, source_9);
        }
        case "usedInProducts": {
            return (source_10) => Dto_sortBy(direction, (s_10) => s_10.ProductIds.length, source_10);
        }
        default: {
            return (source) => Dto_sortBy(direction, (s) => s.MaterialNo, source);
        }
    }
}

function Dto_ProjectModule_get(no, entities) {
    return map_3(Dto_ProjectModule_toEntity, tryHead(filter_9((p) => (p.MaterialNo === no), entities)));
}

const Dto_ProjectModule_entitySet = new EntitySet$3(Dto_ProjectModule_toEntity, uncurry(2, Dto_ProjectModule_createFilter), uncurry(2, Dto_ProjectModule_createLookupFilter), Dto_ProjectModule_createQuery, Dto_ProjectModule_get);

class Dto_ProductGroupPlant extends Record {
    constructor(ProductGroupPlantId, Name, Language) {
        super();
        this.ProductGroupPlantId = ProductGroupPlantId;
        this.Name = Name;
        this.Language = Language;
    }
}

function Dto_ProductGroupPlant$reflection() {
    return record_type("Fame.Fts.Toolbox.SparePartInfo.UI.SimpleContext.Dto.ProductGroupPlant", [], Dto_ProductGroupPlant, () => [["ProductGroupPlantId", string_type], ["Name", string_type], ["Language", string_type]]);
}

class Dto_ProductHierarchy extends Record {
    constructor(ProductHierarchyId, Name, Language) {
        super();
        this.ProductHierarchyId = ProductHierarchyId;
        this.Name = Name;
        this.Language = Language;
    }
}

function Dto_ProductHierarchy$reflection() {
    return record_type("Fame.Fts.Toolbox.SparePartInfo.UI.SimpleContext.Dto.ProductHierarchy", [], Dto_ProductHierarchy, () => [["ProductHierarchyId", string_type], ["Name", string_type], ["Language", string_type]]);
}

class Dto_Spart extends Record {
    constructor(SpartNo, Name, Language) {
        super();
        this.SpartNo = SpartNo;
        this.Name = Name;
        this.Language = Language;
    }
}

function Dto_Spart$reflection() {
    return record_type("Fame.Fts.Toolbox.SparePartInfo.UI.SimpleContext.Dto.Spart", [], Dto_Spart, () => [["SpartNo", string_type], ["Name", string_type], ["Language", string_type]]);
}

class Dto_Creditor extends Record {
    constructor(CreditorNo, Name) {
        super();
        this.CreditorNo = CreditorNo;
        this.Name = Name;
    }
}

function Dto_Creditor$reflection() {
    return record_type("Fame.Fts.Toolbox.SparePartInfo.UI.SimpleContext.Dto.Creditor", [], Dto_Creditor, () => [["CreditorNo", string_type], ["Name", string_type]]);
}

class Dto_SerialNoHint extends Record {
    constructor(Prefix, Hint) {
        super();
        this.Prefix = Prefix;
        this.Hint = Hint;
    }
}

function Dto_SerialNoHint$reflection() {
    return record_type("Fame.Fts.Toolbox.SparePartInfo.UI.SimpleContext.Dto.SerialNoHint", [], Dto_SerialNoHint, () => [["Prefix", string_type], ["Hint", string_type]]);
}

class Dto_Lookups extends Record {
    constructor(ProductHierarchies, ProductGroupPlants, Creditors, Sparts, SparePartChains, SerialNoHints) {
        super();
        this.ProductHierarchies = ProductHierarchies;
        this.ProductGroupPlants = ProductGroupPlants;
        this.Creditors = Creditors;
        this.Sparts = Sparts;
        this.SparePartChains = SparePartChains;
        this.SerialNoHints = SerialNoHints;
    }
}

function Dto_Lookups$reflection() {
    return record_type("Fame.Fts.Toolbox.SparePartInfo.UI.SimpleContext.Dto.Lookups", [], Dto_Lookups, () => [["ProductHierarchies", array_type(Dto_ProductHierarchy$reflection())], ["ProductGroupPlants", array_type(Dto_ProductGroupPlant$reflection())], ["Creditors", array_type(Dto_Creditor$reflection())], ["Sparts", array_type(Dto_Spart$reflection())], ["SparePartChains", array_type(Dto_SparePartChain$reflection())], ["SerialNoHints", array_type(Dto_SerialNoHint$reflection())]]);
}

class Dto_Database extends Record {
    constructor(SpareParts, SalesLists, Products, Projects, ProductHierarchies, ProductGroupPlants, Sparts, Creditors, SparePartChains, SerialNoHints) {
        super();
        this.SpareParts = SpareParts;
        this.SalesLists = SalesLists;
        this.Products = Products;
        this.Projects = Projects;
        this.ProductHierarchies = ProductHierarchies;
        this.ProductGroupPlants = ProductGroupPlants;
        this.Sparts = Sparts;
        this.Creditors = Creditors;
        this.SparePartChains = SparePartChains;
        this.SerialNoHints = SerialNoHints;
    }
}

function Dto_Database$reflection() {
    return record_type("Fame.Fts.Toolbox.SparePartInfo.UI.SimpleContext.Dto.Database", [], Dto_Database, () => [["SpareParts", array_type(Dto_SparePart$reflection())], ["SalesLists", array_type(Dto_SalesList$reflection())], ["Products", array_type(Dto_Product$reflection())], ["Projects", array_type(Dto_Project$reflection())], ["ProductHierarchies", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [Locale$reflection(), class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, string_type])])], ["ProductGroupPlants", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [Locale$reflection(), class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, string_type])])], ["Sparts", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [Locale$reflection(), class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, string_type])])], ["Creditors", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, string_type])], ["SparePartChains", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, Dto_SparePartChain$reflection()])], ["SerialNoHints", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, string_type])]]);
}

class Dto_RootFile extends Record {
    constructor(PublishDate, IsInternal, SpareParts, SalesLists, Products, Projects, Lookups) {
        super();
        this.PublishDate = PublishDate;
        this.IsInternal = IsInternal;
        this.SpareParts = SpareParts;
        this.SalesLists = SalesLists;
        this.Products = Products;
        this.Projects = Projects;
        this.Lookups = Lookups;
    }
}

function Dto_RootFile$reflection() {
    return record_type("Fame.Fts.Toolbox.SparePartInfo.UI.SimpleContext.Dto.RootFile", [], Dto_RootFile, () => [["PublishDate", string_type], ["IsInternal", bool_type], ["SpareParts", array_type(string_type)], ["SalesLists", string_type], ["Products", string_type], ["Projects", string_type], ["Lookups", string_type]]);
}

class Dto_SearchResults extends Record {
    constructor(SpareParts, SalesLists, Products, Projects) {
        super();
        this.SpareParts = SpareParts;
        this.SalesLists = SalesLists;
        this.Products = Products;
        this.Projects = Projects;
    }
}

function Dto_SearchResults$reflection() {
    return record_type("Fame.Fts.Toolbox.SparePartInfo.UI.SimpleContext.Dto.SearchResults", [], Dto_SearchResults, () => [["SpareParts", array_type(Dto_SparePart$reflection())], ["SalesLists", array_type(Dto_SalesList$reflection())], ["Products", array_type(Dto_Product$reflection())], ["Projects", array_type(Dto_Project$reflection())]]);
}

const Dto_SearchResultsModule_empty = new Dto_SearchResults(new Array(0), new Array(0), new Array(0), new Array(0));

export function queryEntities(entitySet, queries, lookup, entities) {
    const queryFilter = isEmpty(queries) ? (void 0) : partialApply(1, entitySet.createQuery, [queries]);
    const lookupFilter = map_3(curry(2, entitySet.createLookupFilter), lookup);
    return entities.filter((entity) => forAll_1((f) => f(entity), choose((x) => x, ofArray([queryFilter, lookupFilter]))));
}

export function sortByDirection(direction, orderFun, entities) {
    if (direction.tag === 1) {
        return sortByDescending(orderFun, entities, {
            Compare: compare,
        });
    }
    else {
        return sortBy(orderFun, entities, {
            Compare: compare,
        });
    }
}

class EntitySets extends Record {
    constructor(SpareParts, SalesLists, Products, Projects) {
        super();
        this.SpareParts = SpareParts;
        this.SalesLists = SalesLists;
        this.Products = Products;
        this.Projects = Projects;
    }
}

function EntitySets$reflection() {
    return record_type("Fame.Fts.Toolbox.SparePartInfo.UI.SimpleContext.EntitySets", [], EntitySets, () => [["SpareParts", EntitySet$3$reflection(Dto_SparePart$reflection(), SparePart$reflection(), SparePartFilter$reflection())], ["SalesLists", EntitySet$3$reflection(Dto_SalesList$reflection(), SalesList$reflection(), unit_type)], ["Products", EntitySet$3$reflection(Dto_Product$reflection(), Product$reflection(), ProductFilter$reflection())], ["Projects", EntitySet$3$reflection(Dto_Project$reflection(), Project$reflection(), ProjectFilter$reflection())]]);
}

function createContext(publishDate, isInternal, db) {
    let matchValue_2, outArg_2;
    const getCreditorName = (creditorId) => {
        if (isNullOrEmpty(creditorId)) {
            return "";
        }
        else {
            let matchValue;
            let outArg = null;
            matchValue = [FSharpMap__TryGetValue(db.Creditors, creditorId, new FSharpRef(() => outArg, (v) => {
                outArg = v;
            })), outArg];
            if (matchValue[0]) {
                return matchValue[1];
            }
            else {
                return "";
            }
        }
    };
    const getSparePartChain = (chainId) => {
        if (isNullOrEmpty(chainId)) {
            return void 0;
        }
        else {
            let matchValue_1;
            let outArg_1 = null;
            matchValue_1 = [FSharpMap__TryGetValue(db.SparePartChains, chainId, new FSharpRef(() => outArg_1, (v_1) => {
                outArg_1 = v_1;
            })), outArg_1];
            if (matchValue_1[0]) {
                return Dto_SparePartChainModule_toEntity(matchValue_1[1]);
            }
            else {
                return void 0;
            }
        }
    };
    const entitySets = new EntitySets(Dto_SparePartModule_getEntitySet(getCreditorName, getSparePartChain), Dto_SalesListModule_entitySet(), Dto_ProductModule_entitySet, Dto_ProjectModule_entitySet);
    let lastSearchResult = Dto_SearchResultsModule_empty;
    let lastSearch = void 0;
    const search = (filter) => {
        const currentSearch = [filter.Query, filter.Lookup];
        if (equals(lastSearch, currentSearch)) {
            return lastSearchResult;
        }
        else {
            let queries_4;
            const query = filter.Query;
            if (query != null) {
                const query_1 = query;
                queries_4 = toArray(filter_9((arg) => (!isNullOrEmpty(arg)), split([" "], query_1.toLowerCase())));
            }
            else {
                queries_4 = (new Array(0));
            }
            lastSearchResult = (new Dto_SearchResults(((lookup) => queryEntities(entitySets.SpareParts, queries_4, lookup, db.SpareParts))(filter.Lookup), ((lookup_1) => queryEntities(entitySets.SalesLists, queries_4, lookup_1, db.SalesLists))(filter.Lookup), ((lookup_2) => queryEntities(entitySets.Products, queries_4, lookup_2, db.Products))(filter.Lookup), ((lookup_3) => queryEntities(entitySets.Projects, queries_4, lookup_3, db.Projects))(filter.Lookup)));
            lastSearch = currentSearch;
            return lastSearchResult;
        }
    };
    const getCounts = (searchResults) => {
        const SpareParts = searchResults.SpareParts.length | 0;
        const SalesLists = searchResults.SalesLists.length | 0;
        return new ResultCounts(searchResults.Products.length, searchResults.Projects.length, SpareParts, SalesLists);
    };
    const getSkip = (page, truncate) => ((page - 1) * truncate);
    const countBy = (projection, items) => (window.countBy(projection, items));
    const collectHierarchies = (hierarchies) => toList(collect((tupledArg_1) => {
        const all = tupledArg_1[1];
        return append([[tupledArg_1[0], sumBy((tuple) => tuple[1], all, {
            GetZero: () => 0,
            Add: (x_2, y_1) => (x_2 + y_1),
        })]], all);
    }, groupBy((tupledArg) => truncate_6(2, tupledArg[0]), countBy((x) => x, hierarchies), {
        Equals: (x_1, y) => (x_1 === y),
        GetHashCode: stringHash,
    })));
    const filterSpareParts = (filter_1, searchResults_1) => filter_9(Dto_SparePartModule_createFilter(filter_1.SparePartFilter), searchResults_1.SpareParts);
    const filteredProducts = (filter_4, searchResults_4) => filter_9(Dto_ProductModule_createFilter(filter_4.ProductFilter), searchResults_4.Products);
    const filteredProjects = (filter_6, searchResults_6) => filter_9(Dto_ProjectModule_createFilter(filter_6.ProjectFilter), searchResults_6.Projects);
    return new Context((matchValue_2 = ((outArg_2 = minValue_1(), [tryParse_1(publishDate, new FSharpRef(() => outArg_2, (v_2) => {
        outArg_2 = v_2;
    })), outArg_2])), matchValue_2[0] ? matchValue_2[1] : minValue_1()), isInternal, (filter_2) => {
        let spareParts, order;
        const truncate_1 = filter_2.PageSize | 0;
        const skip = getSkip(filter_2.Page.SparePartPage, truncate_1) | 0;
        const searchResults_2 = search(filter_2);
        const results = toArray((spareParts = filterSpareParts(filter_2, searchResults_2), (order = filter_2.Order.SparePartOrder, (order != null) ? Dto_SparePartModule_sortByField(order[1], order[0], getCreditorName)(spareParts) : spareParts)));
        return [getCounts(searchResults_2), new SparePartSearchResult(toResultList(skip, truncate_1, (sp) => Dto_SparePartModule_toEntity(getCreditorName, getSparePartChain, sp), results), length(results), ofArray(countBy((sp_1) => sp_1.SPART, searchResults_2.SpareParts)), collectHierarchies(map_2((sp_2) => sp_2.ProductHierarchy, searchResults_2.SpareParts)), ofArray(countBy((sp_3) => sp_3.EKGRP, searchResults_2.SpareParts)), ofArray(countBy((sp_4) => sp_4.ZZPLAKT, searchResults_2.SpareParts)))];
    }, (filter_3) => {
        let order_1;
        const truncate_2 = filter_3.PageSize | 0;
        const skip_1 = getSkip(filter_3.Page.SalesListPage, truncate_2) | 0;
        const searchResults_3 = search(filter_3);
        const results_1 = toArray(((order_1 = filter_3.Order.SalesListOrder, (salesLists) => ((order_1 != null) ? Dto_SalesListModule_sortByField(order_1[1], order_1[0])(salesLists) : salesLists)))(searchResults_3.SalesLists));
        return [getCounts(searchResults_3), new SalesListSearchResult(toResultList(skip_1, truncate_2, Dto_SalesListModule_toEntity, results_1), length(results_1))];
    }, (filter_5) => {
        let products, order_2, Products, FilteredCount, Hierarchies, ProductGroupPlants;
        const truncate_3 = filter_5.PageSize | 0;
        const skip_2 = getSkip(filter_5.Page.ProductPage, truncate_3) | 0;
        const searchResults_5 = search(filter_5);
        const results_2 = toArray((products = filteredProducts(filter_5, searchResults_5), (order_2 = filter_5.Order.ProductOrder, (order_2 != null) ? Dto_ProductModule_sortByField(order_2[1], order_2[0])(products) : products)));
        return [getCounts(searchResults_5), (Products = toResultList(skip_2, truncate_3, Dto_ProductModule_toEntity, results_2), (FilteredCount = (length(results_2) | 0), (Hierarchies = collectHierarchies(map_2((sp_5) => sp_5.ProductHierarchy, searchResults_5.Products)), (ProductGroupPlants = toList(Array_countBy((sp_6) => sp_6.ProductGroupPlant, searchResults_5.Products, {
            Equals: (x_3, y_2) => (x_3 === y_2),
            GetHashCode: stringHash,
        })), new ProductSearchResult(Products, FilteredCount, Hierarchies, toList(Array_countBy((sp_7) => sp_7.ZZPLAKT, searchResults_5.Products, {
            Equals: (x_4, y_3) => (x_4 === y_3),
            GetHashCode: stringHash,
        })), ProductGroupPlants)))))];
    }, (filter_7) => {
        let projects, order_3, Projects, FilteredCount_1, Hierarchies_1, ProductGroupPlants_1;
        const truncate_4 = filter_7.PageSize | 0;
        const skip_3 = getSkip(filter_7.Page.ProjectPage, truncate_4) | 0;
        const searchResults_7 = search(filter_7);
        const results_3 = toArray((projects = filteredProjects(filter_7, searchResults_7), (order_3 = filter_7.Order.ProjectOrder, (order_3 != null) ? Dto_ProjectModule_sortByField(order_3[1], order_3[0])(projects) : projects)));
        return [getCounts(searchResults_7), (Projects = toResultList(skip_3, truncate_4, Dto_ProjectModule_toEntity, results_3), (FilteredCount_1 = (length(results_3) | 0), (Hierarchies_1 = collectHierarchies(map_2((sp_8) => sp_8.ProductHierarchy, searchResults_7.Projects)), (ProductGroupPlants_1 = toList(Array_countBy((sp_9) => sp_9.ProductGroupPlant, searchResults_7.Projects, {
            Equals: (x_5, y_4) => (x_5 === y_4),
            GetHashCode: stringHash,
        })), new ProjectSearchResult(Projects, FilteredCount_1, Hierarchies_1, toList(Array_countBy((sp_10) => sp_10.ZZPLAKT, searchResults_7.Products, {
            Equals: (x_6, y_5) => (x_6 === y_5),
            GetHashCode: stringHash,
        })), ProductGroupPlants_1)))))];
    }, (sparePartId) => singleton.Delay(() => singleton.Bind(Http_get(ExternalUrl.MaterialResources(sparePartId)), (_arg1_1) => ((_arg1_1[0] !== 200) ? singleton.Return(empty()) : singleton.Return(JSON.parse(_arg1_1[1]))))), (arg_1) => getCounts(search(arg_1)), (tr, filter_8) => {
        const searchResults_8 = search(filter_8);
        const sparePartSheetData = new SheetData$1(truncate_5(10000, filterSpareParts(filter_8, searchResults_8)), [new Col$1(tr.Field.MaterialNo, (s) => some(s.MaterialNo)), new Col$1(tr.Field.PartNumber, (s_1) => some(s_1.PartNumber)), new Col$1(tr.Field.Description, (s_2) => some(s_2.Description)), new Col$1(tr.Field.DescriptionDE, (s_3) => some(s_3.DescriptionDe)), new Col$1(tr.Field.Division, (s_4) => some(s_4.SPART)), new Col$1(tr.Field.Hierarchy, (s_5) => some(s_5.ProductHierarchy)), new Col$1(tr.Field.VendorPartNo, (s_6) => some(s_6.VendorPartNo)), new Col$1(tr.Field.TechnicalInfo, (s_7) => some(concatNewLine(s_7.TechnicalInfo))), new Col$1(tr.Field.ReturnCode, (s_8) => some(s_8.ReturnCode)), new Col$1(tr.Field.RepairCode, (s_9) => some(s_9.RepairCode)), new Col$1(tr.Field.ListPrice, (s_10) => map_3((arg0_21) => arg0_21, s_10.ListPrice)), new Col$1(tr.Field.CreditPrice, (s_11) => map_3((arg0_22) => arg0_22, s_11.CreditPrice)), new Col$1(tr.Field.Currency, (s_12) => some(s_12.Currenry)), new Col$1(tr.Field.CRU, (s_13) => some(s_13.CRU)), new Col$1(tr.Field.SubstituteMaterial, (s_14) => some(s_14.SubstituteMaterial)), new Col$1(tr.Field.AlternativePart, (s_15) => some(s_15.AlternativePart)), new Col$1(tr.Field.CentralLocal, (s_16) => some(s_16.CentrolLocalFlag)), new Col$1(tr.Field.MainAlternativePart, (s_17) => some(s_17.MainAlternativePart)), new Col$1(tr.Field.EndOfServiceMax, (s_18) => map_3((arg0_35) => arg0_35, Dto_tryParseDate(s_18.EOLL))), new Col$1(tr.Field.EndOfService, (s_19) => map_3((arg0_36) => arg0_36, Dto_tryParseDate(s_19.EOLC))), new Col$1(tr.Field.Engineer, (s_20) => some(s_20.ZZPLAKT)), new Col$1(tr.Field.Planner, (s_21) => some(s_21.EKGRP)), new Col$1(tr.Field.CommodityCode, (s_22) => some(s_22.CommodityCode)), new Col$1(tr.Field.LegalControlDE, (s_23) => some(s_23.LegalControlDE)), new Col$1(tr.Field.LegalControlEN, (s_24) => some(s_24.LegalControlEN)), new Col$1(tr.Field.CountryOfOrigin, (s_25) => some(s_25.CountryofOrigin)), new Col$1(tr.Field.RoHSKz, (s_26) => some(s_26.RoHSKz)), new Col$1(tr.Field.DangerousGoods, (s_27) => some(s_27.DangerousGoods)), new Col$1(tr.Field.HazardousMaterialNumber, (s_28) => some(s_28.HazardousMaterialNumber)), new Col$1(tr.Field.ArticleNumberBattery1, (s_29) => some(s_29.ArticleNumberBattery1)), new Col$1(tr.Field.ArticleNumberBattery2, (s_30) => some(s_30.ArticleNumberBattery2)), new Col$1(tr.Field.ExternalPackaging, (s_31) => some(s_31.ExternalPackaging)), new Col$1(tr.Field.InternalPackaging, (s_32) => some(s_32.InternalPackaging)), new Col$1(tr.Field.ESDBag, (s_33) => some(s_33.ESDBag)), new Col$1(tr.Field.GrossWeight, (s_34) => map_3((arg0_65) => arg0_65, s_34.GrossWeight)), new Col$1(tr.Field.NetWeight, (s_35) => map_3((arg0_66) => arg0_66, s_35.NetWeight)), new Col$1(tr.Field.WeightUnit, (s_36) => some(s_36.WeightUnit)), new Col$1(tr.Field.Volume, (s_37) => map_3((arg0_69) => arg0_69, s_37.Volume)), new Col$1(tr.Field.VolumeUnit, (s_38) => some(s_38.VolumeUnit)), new Col$1(tr.Field.Length, (s_39) => map_3((arg0_72) => arg0_72, s_39.Length)), new Col$1(tr.Field.Width, (s_40) => map_3((arg0_73) => arg0_73, s_40.Width)), new Col$1(tr.Field.Height, (s_41) => map_3((arg0_74) => arg0_74, s_41.Height)), new Col$1(tr.Field.DimensionUnit, (s_42) => some(s_42.DimensionUnit)), new Col$1(tr.Field.CriticalPart, (s_43) => map_3((arg0_77) => arg0_77, s_43.CriticalPart)), new Col$1(tr.Field.SupplierCreditorNo, (s_44) => some(s_44.SupplierCreditorNo)), new Col$1(tr.Field.RepairerCreditorNo, (s_45) => some(s_45.RepairerCreditorNo)), new Col$1(tr.Field.RepairerPartNo, (s_46) => some(s_46.RepairerPartNo)), new Col$1(tr.Field.GeneralInfo, (s_47) => some(concatNewLine(s_47.GeneralInfo))), new Col$1(tr.Field.PrecheckInfo, (s_48) => some(concatNewLine(s_48.PrecheckInfo))), new Col$1(tr.Field.MaterialKind, (s_49) => some(s_49.MaterialKind)), new Col$1(tr.Field.NotInStore, (s_50) => some(s_50.NotInStore)), new Col$1(tr.Field.MoreInfo, (s_51) => some(s_51.MoreInfo)), new Col$1(tr.Field.UseUp, (s_52) => some(s_52.UseUp)), new Col$1(tr.Field.LastCall, (s_53) => some(s_53.LastCall)), new Col$1(tr.Field.RepairOnly, (s_54) => some(s_54.RepairOnly))]);
        const salesListSheetData = new SheetData$1(truncate_5(10000, searchResults_8.SalesLists), [new Col$1(tr.Field.MaterialNo, (s_55) => some(s_55.MaterialNo)), new Col$1(tr.Field.PartNumber, (s_56) => some(s_56.PartNumber)), new Col$1(tr.Field.Description, (s_57) => some(s_57.Description))]);
        const productSheetData = new SheetData$1(truncate_5(10000, filteredProducts(filter_8, searchResults_8)), [new Col$1(tr.Field.MaterialNo, (s_58) => some(s_58.MaterialNo)), new Col$1(tr.Field.ProductNo, (s_59) => some(s_59.Productno)), new Col$1(tr.Field.PartNumber, (s_60) => some(s_60.PartNumber)), new Col$1(tr.Field.Description, (s_61) => some(s_61.Description)), new Col$1(tr.Field.DescriptionDE, (s_62) => some(s_62.DescriptionDE)), new Col$1(tr.Field.ProductGroupPlant, (s_63) => some(s_63.ProductGroupPlant)), new Col$1(tr.Field.Hierarchy, (s_64) => some(s_64.ProductHierarchy)), new Col$1(tr.Field.EndOfService, (s_65) => map_3((arg0_120) => arg0_120, Dto_tryParseDate(s_65.EndofLife))), new Col$1(tr.Field.CRU, (s_66) => some(s_66.CRU)), new Col$1(tr.Field.CentralLocal, (s_67) => some(s_67.CentrolLocalFlag)), new Col$1(tr.Field.PlanningInformation, (s_68) => some(join("\n", s_68.PlanningInformation))), new Col$1(tr.Field.EndOfServiceMax, (s_69) => map_3((arg0_127) => arg0_127, Dto_tryParseDate(s_69.ZZLVINT))), new Col$1(tr.Field.Engineer, (s_70) => some(s_70.ZZPLAKT)), new Col$1(tr.Field.EXTWG, (s_71) => some(s_71.EXTWG)), new Col$1(tr.Field.CreationDate, (s_72) => map_3((arg0_132) => arg0_132, Dto_tryParseDate(s_72.CreationDate)))]);
        const projectSheetData = new SheetData$1(truncate_5(10000, filteredProjects(filter_8, searchResults_8)), [new Col$1(tr.Field.MaterialNo, (s_73) => some(s_73.MaterialNo)), new Col$1(tr.Field.ProductNo, (s_74) => some(s_74.Productno)), new Col$1(tr.Field.PartNumber, (s_75) => some(s_75.PartNumber)), new Col$1(tr.Field.Description, (s_76) => some(s_76.Description)), new Col$1(tr.Field.DescriptionDE, (s_77) => some(s_77.DescriptionDE)), new Col$1(tr.Field.ProductGroupPlant, (s_78) => some(s_78.ProductGroupPlant)), new Col$1(tr.Field.Hierarchy, (s_79) => some(s_79.ProductHierarchy)), new Col$1(tr.Field.EndOfService, (s_80) => map_3((arg0_147) => arg0_147, Dto_tryParseDate(s_80.EndOfLife))), new Col$1(tr.Field.EndOfServiceMax, (s_81) => map_3((arg0_148) => arg0_148, Dto_tryParseDate(s_81.ZZLVINT))), new Col$1(tr.Field.Engineer, (s_82) => some(s_82.ZZPLAKT))]);
        const workbook = xlsx.utils.book_new();
        xlsx.utils.book_append_sheet(workbook, Worksheet_ofData(sparePartSheetData), tr.SpareParts);
        xlsx.utils.book_append_sheet(workbook, Worksheet_ofData(salesListSheetData), tr.SalesLists);
        xlsx.utils.book_append_sheet(workbook, Worksheet_ofData(productSheetData), tr.Products);
        xlsx.utils.book_append_sheet(workbook, Worksheet_ofData(projectSheetData), tr.Projects);
        xlsx.writeFile(workbook, "spi-export.xlsx");
    }, (_arg2) => entitySets.SpareParts.get(_arg2.fields[0], ofArray_1(db.SpareParts)), (_arg3) => entitySets.SalesLists.get(_arg3.fields[0], ofArray_1(db.SalesLists)), (_arg4) => entitySets.Products.get(_arg4.fields[0], ofArray_1(db.Products)), (_arg5) => entitySets.Projects.get(_arg5.fields[0], ofArray_1(db.Projects)), () => db.ProductHierarchies, () => db.ProductGroupPlants, () => db.Sparts, () => db.SerialNoHints);
}

export const version = 2;

function load(fileName) {
    return singleton.Delay(() => singleton.Bind(Http_get(`data/v${version}/${fileName}`), (_arg1) => {
        const statusCode = _arg1[0] | 0;
        return (statusCode !== 200) ? singleton.Return(new FSharpResult$2(1, toText(printf("Invalid status code while loading database: %d"))(statusCode))) : singleton.Return(new FSharpResult$2(0, JSON.parse(_arg1[1])));
    }));
}

export function loadSimpleContext() {
    return AsyncResultCE_AsyncResultBuilder__Delay_Z64727ECD(AsyncResultCE_asyncResult, () => {
        const asyncResult_4 = load("spi.json");
        return singleton.Delay(() => singleton.Bind(asyncResult_4, (_arg1_6) => {
            let files, asyncResult_3, x;
            const result_11 = _arg1_6;
            return (result_11.tag === 1) ? singleton.Return(new FSharpResult$2(1, result_11.fields[0])) : singleton.ReturnFrom((files = result_11.fields[0], (asyncResult_3 = ((x = parallel(map_1(load, files.SpareParts)), singleton.Bind(x, (arg) => {
                const value = foldBack((res, all) => {
                    const matchValue = [all, res];
                    const copyOfStruct = matchValue[0];
                    if (copyOfStruct.tag === 0) {
                        const copyOfStruct_1 = matchValue[1];
                        if (copyOfStruct_1.tag === 1) {
                            return new FSharpResult$2(1, copyOfStruct_1.fields[0]);
                        }
                        else {
                            return new FSharpResult$2(0, cons(copyOfStruct_1.fields[0], copyOfStruct.fields[0]));
                        }
                    }
                    else {
                        return all;
                    }
                }, arg, new FSharpResult$2(0, empty_1()));
                return singleton.Return(value);
            }))), singleton.Delay(() => singleton.Bind(asyncResult_3, (_arg1_5) => {
                let asyncResult_2;
                const result_10 = _arg1_5;
                return (result_10.tag === 1) ? singleton.Return(new FSharpResult$2(1, result_10.fields[0])) : singleton.ReturnFrom((asyncResult_2 = load(files.SalesLists), singleton.Delay(() => singleton.Bind(asyncResult_2, (_arg1_4) => {
                    let asyncResult_1;
                    const result_9 = _arg1_4;
                    return (result_9.tag === 1) ? singleton.Return(new FSharpResult$2(1, result_9.fields[0])) : singleton.ReturnFrom((asyncResult_1 = load(files.Products), singleton.Delay(() => singleton.Bind(asyncResult_1, (_arg1_3) => {
                        let asyncResult;
                        const result_8 = _arg1_3;
                        return (result_8.tag === 1) ? singleton.Return(new FSharpResult$2(1, result_8.fields[0])) : singleton.ReturnFrom((asyncResult = load(files.Projects), singleton.Delay(() => singleton.Bind(asyncResult, (_arg1_2) => {
                            let x_1_2;
                            const result_7 = _arg1_2;
                            return (result_7.tag === 1) ? singleton.Return(new FSharpResult$2(1, result_7.fields[0])) : singleton.ReturnFrom((x_1_2 = load(files.Lookups), singleton.Bind(x_1_2, (arg_1) => {
                                const value_3 = Result_Map((_arg6) => {
                                    const lookups = _arg6;
                                    const createLocaleMap = (langKeyValues) => ofSeq(map_1((tupledArg_3) => [tupledArg_3[0], ofSeq(map_1((tupledArg_4) => [tupledArg_4[1], tupledArg_4[2]], tupledArg_3[1]))], groupBy((tupledArg_2) => value_5(tupledArg_2[0]), filter_9((tupledArg_1) => (!equals(tupledArg_1[0], void 0)), map_1((tupledArg) => [LocaleModule_tryParse(tupledArg[0]), tupledArg[1], tupledArg[2]], langKeyValues)), {
                                        Equals: equals,
                                        GetHashCode: safeHash,
                                    })));
                                    const productHierarchyMap = createLocaleMap(map_1((h) => [h.Language, h.ProductHierarchyId, h.Name], lookups.ProductHierarchies));
                                    const productGroupPlantMap = createLocaleMap(map_1((h_1) => [h_1.Language, h_1.ProductGroupPlantId, h_1.Name], lookups.ProductGroupPlants));
                                    const spartsMap = createLocaleMap(map_1((s) => [s.Language, s.SpartNo, s.Name], lookups.Sparts));
                                    const creditorMap = ofSeq(map_1((c) => [c.CreditorNo, c.Name], lookups.Creditors));
                                    const sparePartChainMap = ofSeq(map_1((c_1) => [c_1.ChainId, c_1], lookups.SparePartChains));
                                    const serialNoHintsMap = ofSeq(map_1((h_2) => [h_2.Prefix, h_2.Hint], lookups.SerialNoHints));
                                    return createContext(files.PublishDate, files.IsInternal, new Dto_Database(toArray(collect((x_4) => x_4, result_10.fields[0])), result_9.fields[0], result_8.fields[0], result_7.fields[0], productHierarchyMap, productGroupPlantMap, spartsMap, creditorMap, sparePartChainMap, serialNoHintsMap));
                                }, arg_1);
                                return singleton.Return(value_3);
                            })));
                        }))));
                    }))));
                }))));
            })))));
        }));
    });
}

